<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <circle
            cx="9"
            cy="9"
            r="6"
            :stroke="buttonColor"
            stroke-width="2"
            fill="none"
        />
        <path
            d="M14.5 14.5L18 18"
            :stroke="buttonColor"
            stroke-width="2"
            stroke-linecap="round"
        />
    </svg>
</template>

<script setup>
    import { useAccountStore } from '~/stores/accountStore.ts';

    const { buttonColor } = useAccountStore().state;
</script> 
